import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { AdminPayPutOrdersRequest } from "./api";
import { cancelPayOutOrderBySupport, completePayOutOrder, getAdminPayOutOrders } from "./slice";

export const useAdminPayOutOrders = () => {
  const state = useAppSelector((state) => state.adminPayOutOrders);
  const dispatch = useAppDispatch();

  const getAdminPayOutOrdersHandler = useCallback(
    (data?: AdminPayPutOrdersRequest) => dispatch(getAdminPayOutOrders({ data })),
    [dispatch]
  );

  const completePayOutOrderHandler = useCallback(
    (orderId: string) => dispatch(completePayOutOrder({ orderId })),
    [dispatch]
  );

  const cancelPayOutOrderBySupportHandler = useCallback(
    (orderId: string, remove_pool?: boolean) => dispatch(cancelPayOutOrderBySupport({ orderId, remove_pool })),
    [dispatch]
  );

  return {
    state,
    getAdminPayOutOrders: getAdminPayOutOrdersHandler,
    completePayOutOrder: completePayOutOrderHandler,
    cancelPayOutOrderBySupport: cancelPayOutOrderBySupportHandler,
  };
};
